var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "bulkWithdraw",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "warning-wrap withdraw-warning"
  }, [_c('i', {
    staticClass: "fa fa-triangle-exclamation"
  })]), _c('div', [_c('h6', {}, [_vm._v("Withdraw this Enrollment?")]), _c('p', {
    staticClass: "light-txt"
  }, [_vm._v(" You're about to withdraw the selected " + _vm._s(_vm.isIndividualEnrollment ? 'individual enrollment' : 'group enrollment') + ". Once withdrawn, the " + _vm._s(_vm.isIndividualEnrollment ? 'individual enrollment' : 'group enrollment') + " will be removed from the pending list and this action can't be undone. ")])])]), _c('div', {
    staticClass: "d-flex justify-content-end flex-column-reverse flex-sm-row mt-3 gap-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _c('b-button', {
    staticClass: "univ-btn m-0 px-5 univ-withdraw",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.submitBulkWithdraw
    }
  }, [_vm._v(_vm._s(_vm.isIndividualEnrollment ? 'Withdraw Individual Enrollment' : 'Withdraw Group Enrollment'))])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }